<template>
  <div class="weezie-logo-management"  @click="$router.push({ name: 'hub' })" :style="route_name==='workspaces'? {    width: '160px'}:{}">
    <img :src="image_path" alt="">
  </div>
</template>

<script>
//    width: 160px;
export default {
  name: "WeezieLogo",
  props: ["sidebarIsOpen"],
  computed:{
    route_name(){
      return this.$route.name;
    },
    image_path(){
      if (this.sidebarIsOpen
        && (
          this.route_name === 'field-management-activities' ||
          this.route_name === 'template-activities' ||
          this.route_name === "template-tasks" ||
          this.route_name === "template-activity-create" ||
          this.route_name === "template-task-create" ||
          this.route_name === "template-task" ||
          this.route_name === "template-activity" ||
          this.route_name === "template-activity-edit"||
          this.route_name === "template-task-edit" ||
          this.route_name === "field-management-activity" ||
          this.route_name === "field-management-task"
        )
      ) {
        return require("@/assets/logos/weezie_tasks_compact_blue.png");
      } else if (this.route_name === "dashboard") {
        return require("@/assets/logos/weezie_bi.png");
      } else if(this.sidebarIsOpen){
        return require("@/assets/logos/weezie_fiber_compact_blue.png");
      }

      if(this.route_name === 'workspaces'){
        return require("@/assets/logos/weezie_fiber_extended_blue.png");
      }else{
        return require("@/assets/logos/weezie_icon.png");
      }

    }
  },
  mounted() {

  }
};
</script>

<style scoped>
div{
  display: inline-block;
}

.weezie-logo-management{
  width: 36px;
}

.weezie-logo-management.hub-button-reduced{
  width: 40px;
}

</style>



// WEBPACK FOOTER //
// src/assets/logos/WeezieLogo.vue